import {
  DataPageLimit,
  DataQueryParamPersonName,
  DataQueryParamFrom,
  DataQueryParamTo,
  DataPersonEntity,
} from '@edgvr-front/data/domain';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { getSelectors } from '@ngrx/router-store';
import {
  DATA_PERSONS_FEATURE_KEY,
  DataPersonsState,
  dataPersonsAdapter,
} from '../reducers';

const dataPersonsState = createFeatureSelector<DataPersonsState>(
  DATA_PERSONS_FEATURE_KEY
);

const { selectAll } = dataPersonsAdapter.getSelectors();
const { selectQueryParams } = getSelectors();

export const dataPersons = createSelector(
  dataPersonsState,
  (state: DataPersonsState) =>
    selectAll(state).map((_) => DataPersonEntity.factory(_))
);

export const selectedDataPerson = createSelector(
  dataPersonsState,
  (state: DataPersonsState) => {
    const selectedDataPerson = state.selectedDataPersonId
      ? state.entities[state.selectedDataPersonId]
      : null;

    return selectedDataPerson
      ? DataPersonEntity.factory(selectedDataPerson)
      : null;
  }
);

export const selectedDataModule = createSelector(
  dataPersonsState,
  selectedDataPerson,
  (state: DataPersonsState, dataPerson: null | DataPersonEntity) => {
    const index = state.selectedDataModuleIndex;
    if (index === null) {
      return null;
    }

    const dataModule = dataPerson?.value.data.modules[index] || null;

    return dataModule;
  }
);

export const count = createSelector(
  dataPersonsState,
  (state: DataPersonsState) => state.count
);
export const from = createSelector(
  dataPersonsState,
  (state: DataPersonsState) => (state.page - 1) * DataPageLimit
);
export const to = createSelector(
  dataPersonsState,
  (state: DataPersonsState) => state.page * DataPageLimit
);

export const page = createSelector(
  dataPersonsState,
  (state: DataPersonsState) => state.page
);
export const prevPage = createSelector(
  dataPersonsState,
  (state: DataPersonsState) => (state.page > 1 ? state.page - 1 : 0)
);
export const nextPage = createSelector(
  dataPersonsState,
  (state: DataPersonsState) =>
    state.page * DataPageLimit < state.count ? state.page + 1 : 0
);

export const loading = createSelector(
  dataPersonsState,
  (state: DataPersonsState) => state.loading
);

export const loaded = createSelector(
  dataPersonsState,
  (state: DataPersonsState) => state.loaded
);

export const routerPersonName = createSelector(
  selectQueryParams,
  (queryParams) => queryParams[DataQueryParamPersonName]
);
export const routerFrom = createSelector(
  selectQueryParams,
  (queryParams) => queryParams[DataQueryParamFrom]
);
export const routerTo = createSelector(
  selectQueryParams,
  (queryParams) => queryParams[DataQueryParamTo]
);
